<template>
  <div id="centerLeft1">
    <div id='map' ref="map" style='height: 660px; width: 660px;'></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import cityList from '../utils/cityList';

export default {
  name: '',
  props: {
    areaCode: String,
    areaName: String,
    cityList: Object,
  },
  data() {
    return {
      mapChart: null, // 地图对象
      mapOption: null, // 地图属性
    }
  },
  watch: {
    //监听文件url改变时重新赋值
    areaCode(newVal, oldVal) {
      this.getMap(this.areaName, this.cityList)
      console.log(cityList[newVal].businessList)
    }
  },
  mounted() {
    this.getMap(this.areaName, this.cityList)
  },
  methods: {
    getMap(areaName, cityData) { // 地图
      if (!this.mapChart) {
        this.mapChart = echarts.init(document.getElementById('map'))
      }
      this.mapOption = {
        // 背景颜色
        backgroundColor: 'transparent',
        // 提示浮窗样式
        tooltip: {
          show: true,
          trigger: 'item',
          alwaysShowContent: false,
          backgroundColor: '#0C121C',
          borderColor: 'rgba(0, 0, 0, 0.16);',
          hideDelay: 100,
          triggerOn: 'mousemove',
          enterable: true,
          textStyle: {
            color: '#DADADA',
            fontSize: '14',
            width: 20,
            height: 30,
            overflow: 'break'
          },
          showDelay: 100
        },
        map: areaName,
        roam: false, // 是否启缩放和平移
        zoom: 1.1, // 缩放比例
        scaleLimit: {
          min: 1,
          max: 5
        },
        label: {
          normal: {
            show: true,
            fontSize: '14',
            color: '#fff'
          }
        },
        // 地图配置
        geo: {
          map: areaName,
          show: true,
          layoutSize: '100%',
          aspectScale: 0.75,
          layoutCenter: ['50%', '50%'], // 地图位置
          // layoutSize: '118%',
          label: {
            // 通常状态下的样式
            normal: {
              show: true,
              textStyle: {
                color: '#eee'
              }
            },
            // 鼠标放上去的样式
            emphasis: {
              textStyle: {
                color: '#eee'
              }
            }
          },
          // 地图区域的样式设置
          itemStyle: {
            normal: {
              borderColor: 'rgba(147, 235, 248, 1)',
              borderWidth: 1,
              color: {
                type: 'linear-gradient',
                x: 0,
                y: 1500,
                x2: 2500,
                y2: 0,
                colorStops: [{
                  offset: 0,
                  color: '#009DA1' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: '#005B9E' // 50% 处的颜色
                }],
                global: true // 缺省为 false
              },
              opacity: 0.5,
              areaColor: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(147, 235, 248, 0)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(147, 235, 248, .2)' // 100% 处的颜色
                  }
                ],
                globalCoord: false // 缺省为 false
              },
              shadowColor: 'rgba(10,76,139,1)',
              // shadowOffsetX: -2,
              shadowOffsetY: 0,
              shadowBlur: 60,
              emphasis: {
                areaColor: '#2a333d'
              }
            },
            // 鼠标放上去高亮的样式
            emphasis: {
              areaColor: '#389BB7',
              borderWidth: 0
            }
          }
        },
        series: [
        {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: cityList[this.areaCode].businessList,
            symbolSize: 10,
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke',
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: '',
                position: 'right',
                show: false,
              },
            },
            itemStyle: {
              normal: {
                color: '#f00',
                shadowBlur: 10,
                shadowColor: '#333',
              },
            },
            zlevel: 1,
          },
        ]
      }
      // 地图注册，第一个参数的名字必须和option.geo.map一致
      echarts.registerMap(areaName, cityData)
      this.mapChart.setOption(this.mapOption)
      window.addEventListener('resize', () => {
        this.mapChart.resize()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#centerLeft1 {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>